import DataTable from "react-data-table-component";
import "./MovimentazioneSectionTable.scss";
import InnerSpinnerLoading from "../../../Common/InnerSpinnerLoading/InnerSpinnerLoading";
import { EyeIcon, DeleteIcon } from "../../../../assets/icons";
import myDateFormat from "../../../../helpers/utils/myDateFormat";
import { getDataTableCustomStyles } from "../../../../helpers/dataTableThemeStyles";

const customStyles = getDataTableCustomStyles();

// Italian labels configuration
const italianLabels = {
  rows: {
    noRows: "Nessun record da visualizzare",
    perPage: "Righe per pagina:",
  },
  pagination: {
    first: "Prima",
    last: "Ultima",
    previous: "Precedente",
    next: "Successiva",
    showing: "Mostrando",
    of: "di",
    to: "a",
    results: "risultati",
  },
  noData: "Nessun dato disponibile",
  loading: "Caricamento...",
};

const paginationComponentOptions = {
  rowsPerPageText: 'Righe per pagina:',
  rangeSeparatorText: 'di',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Tutti',
};

const MovimentazioneSectionTable = ({
  repertoData,
  movimentazioneData,
  isLoading,
  disabled,
  totalRows,
  handlePerRowsChange,
  handlePageChange,
  handleSort,
  handleMovimentazioneView,
  handleMovimentazioneEdit,
  handleMovimantazioneDelete,
  userCanDeleteMovimentazione
}) => {
  const columns = [
    {
      selector: (row) => row.id,
      cell: (row) => (
        <div className="table-actions">
          <button onClick={() => disabled ? handleMovimentazioneView(row.id) : handleMovimentazioneEdit(row.id)}>
            <EyeIcon fillColor={"currentColor"} />
          </button>
          { !disabled && userCanDeleteMovimentazione && (
            <button onClick={() => handleMovimantazioneDelete(row.id)}>
              <DeleteIcon fillColor={"currentColor"}  />
            </button>
          )}
        </div>
      ),
      width: "70px",
      style: {
        padding: "6px",
      },
    },

    {
      name: "Tipo",
      selector: (row) => row.tipo,
      sortable: true,
    },
    {
      name: "Inizio",
      selector: (row) => row.inizio,
      width: "200px",
      sortable: true,
      cell: (row) => myDateFormat(row.inizio),
    },
    {
      name: "termine",
      selector: (row) => row.termine,
      cell: (row) => myDateFormat(row.termine),
      width: "200px",
      sortable: true,
    },
    {
      name: "Destinazione",
      selector: (row) => row.destinazione,
    },
    {
      name: "Note",
      selector: (row) => row.note,
      sortable: true,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.id === repertoData?.movimentazione?.id,
      style: {
        backgroundColor: "var(--archeo-color)",
        "& .table-actions > button": {
          backgroundColor: "var(--archeo-color)",
          color: "white",
        },
      },
    }
  ]
  return (
    <div className="movimentazione-section-table">
      <DataTable
        columns={columns}
        data={movimentazioneData}
        progressPending={isLoading}
        progressComponent={<InnerSpinnerLoading isLoading={isLoading} />}
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        language={italianLabels}
        paginationComponentOptions={paginationComponentOptions}
      />
    </div>
  );
};

export default MovimentazioneSectionTable;
